<section class="w-full">
  <split-header-section title="Relatório Financeiro"></split-header-section>

  <div class="grid grid-nogutter m-0 nested-grid">
    <div class="col-12">
      <form [formGroup]="formFilter" class="w-full">
        <div class="bg-white px-5 border-round-2xl box-shadow">
          <div class="p-fluid grid py-4">
            <div class="field col-4 m-0">
              <span class="p-float-label">
                <p-dropdown class="w-full" [options]="listYear"  placeholder="Anual" optionLabel="label"
                optionValue="value" formControlName="year"></p-dropdown>
                <label for="float-label" class="text-base">Ano</label>
              </span>
            </div>
            <div class="field col-4 m-0">
              <span class="p-float-label">
                <p-dropdown [showClear]="true" [options]="listUnit" placeholder="Unidade" optionLabel="unitName"
                optionValue="id" formControlName="unit"></p-dropdown>
                <label for="float-label" class="text-base">Unidade</label>
              </span>
            </div>
          </div>
          </div>
      </form>
    </div>
    <div class="col-6">
      <split-card theme="secondary">
        <ng-container card-header>
            <split-text theme="secondery" title="Resultados"
                subtitle="Últimos 12 meses">
            </split-text>
        </ng-container>
        <ng-container card-body>
          <div *ngIf="resultsReportYearMonth" class="w-full">
            <div class="valores_mes flex mt-4">
              <div class="mes_atual flex flex-column align-items-start pr-3">
                {{
                  resultsReportYearMonth.current
                    | currency : "BRL" : "symbol" : "1.2-2"
                }}
                <span class="subtitle"> Lucro mês {{resultsReportYearMonth.labels[resultsReportYearMonth.labels.length - 1]}} </span>
              </div>
              <div
                class="mes_anterior flex flex-column align-items-start justify-content-center pl-3 border-pipe"
              >
                {{
                  resultsReportYearMonth.previous
                    | currency : "BRL" : "symbol" : "1.2-2"
                }}
                <span class="subtitle"> Lucro mês anterior {{resultsReportYearMonth.labels[resultsReportYearMonth.labels.length - 2]}} </span>
              </div>
            </div>
            <split-line
              [highlightLastLabel]="true"
              [data]="resultsReportYearMonth.data"
              [labels]="resultsReportYearMonth.labels"
            ></split-line>
          </div>
        </ng-container>
      </split-card>
    </div>
    <div class="col-6">
      <split-card theme="secondary">
        <ng-container card-header>
          <split-text theme="secondery" [title]="this.appointmentType.label"
            subtitle="Últimos 12 meses">
          </split-text>
        </ng-container>
        <ng-container card-body>
          <split-select-button
            (onOptionClick)="setAppointmentTypeFilter($event)"
            [options]="optionsReport"
          ></split-select-button>
            <div class="valores_mes flex mb-4 mt-3">
              <div
                class="mes_atual flex flex-column align-items-start pr-3"
                style="color: #ff8321"
              >
                {{ this.resultServices.data[this.appointmentType.value]?.count }} {{ this.appointmentType.label }}
                <span class="subtitle"> ao Ano </span>
              </div>
            </div>
            <split-bar
              [disableCurrency]="true"
              [data]="this.resultServices.data[this.appointmentType.value]?.data"
              [columns]="this.resultServices.columns"
              color="#FF8321"
            ></split-bar>
        </ng-container>
      </split-card>
    </div>
    <div class="col-8">
      <split-card theme="secondary">
        <ng-container card-header>
          <split-text theme="secondery" title="Comparativo Receita e despesas"
            subtitle="Últimos 12 meses">
          </split-text>
        </ng-container>
        <ng-container card-body>
          <div class="w-full">
            <div class="valores_mes flex mb-4">
              <div class="mes_atual flex flex-column align-items-start pr-3">
                {{
                  resultsComparativeExpenses.previousRevenue
                    | currency : "BRL" : "symbol" : "1.2-2"
                }}
                <span class="subtitle"> Receita mês {{resultsComparativeExpenses.previousLabel}} </span>
              </div>
              <div
                class="mes_atual flex flex-column align-items-start justify-content-center border-pipe pl-3"
                style="color: #db0000"
              >
                {{
                  resultsComparativeExpenses.previousExpense
                    | currency : "BRL" : "symbol" : "1.2-2"
                }}
                <span class="subtitle"> Despesas mês {{resultsComparativeExpenses.previousLabel}} </span>
              </div>
            </div>

            <split-line
              [data]="resultsComparativeExpenses.data"
              [labels]="resultsComparativeExpenses.labels"
            ></split-line>
          </div>
        </ng-container>
      </split-card>
    </div>
    <div class="col-4">
      <split-card theme="secondary">
        <ng-container card-header>
          <split-text theme="secondery" title="Resultados anual"
            subtitle="Resultado ajustado">
          </split-text>
        </ng-container>
        <ng-container card-body>
          <div class="w-full">
            <div *ngIf="isLoadingAnnualResult" class="flex justify-content-center align-items-center pt-5 mt-5"> 
              <p-progressSpinner  ariaLabel="loading"></p-progressSpinner>
            </div>
            <div *ngIf="!isLoadingAnnualResult">
              <split-report-message-year-month class="mb-3" *ngFor="let result of resultsAnnual"
                [class]="'green-card'"
                [year]="result.ano"
                [label]="'Faturamento total'"
                [percentage]="result.value.percentual"
                [columns]="[{valor: result.value.profit,descricao: 'Lucro'}]"
              ></split-report-message-year-month>
            </div>
          </div>
        </ng-container>
      </split-card>
    </div>
    <div class="col-12">
      <split-results-per-month
          [loading]="isLoadingMonthMov"
          header="Resultados mês a mês"
          [subtitle]="'Resultado ' + selectedOption.name"
          [columns]="receiptMonthly"
          [results]="true">
          <split-group-filter id="monthMov" (onFilterEvent)="onFilterEvent($event)" class="mr-3">
            <split-filter-option [(selected)]="selectedOption" groupId="monthMov" field="result" label="Resultado" [data]="optionResult" key="result"></split-filter-option>
          </split-group-filter>
        </split-results-per-month>
    </div>
  </div>



</section>
